import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ButtonComponent } from '../button/button.component';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-dialog',
  standalone: true,
  imports: [ButtonComponent, CommonModule],
  templateUrl: './dialog.component.html',
  styleUrl: './dialog.component.scss',
})
export class DialogComponent {
  dialogRef = inject(MatDialogRef<DialogComponent>);
  data = inject<any>(MAT_DIALOG_DATA);

  constructor() {
    if (this.data.title) {
      this.dialogRef = inject(MatDialogRef);
    }
  }

  ngOnInit() {
    if (this.dialogRef) {
      this.dialogRef.updateSize('600px');
    }
  }

  onConfirm(): void {
    this.dialogRef.close('data');
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
